import styled from '@emotion/styled';
import {FADE_IN_ANIMATION} from '../styles/animations';
import {RED_CREEK} from '../styles/colors';
import {MediumText} from '../styles/styles';
import {useState} from 'react';
import {SEARCH_BLACKLIST} from './module';
import {Column, Row} from '../layout/flexbox';
import * as Buttons from '../forms/elements/buttons';
import { getResource } from '../language/resources/getResource';
import { IAppState } from '../core/redux/IAppState';
import { useSelector } from 'react-redux';


const ErrorPlaceholder = styled('div')`
  margin-bottom: 10px;
  min-height: 20px;
`;

const ErrorText = styled('span')`
  ${FADE_IN_ANIMATION};
  color: ${RED_CREEK};
  ${MediumText};
  margin-bottom: 10px;
  min-height: 20px;
`;

const TextBox = styled('input')`
  padding: 8px;
  ${MediumText};
  flex-grow: 1;
  min-width: 200px;
  max-width: 600px;
`;

const MinSearchLength = 7;

type Props = {
  onSearch: (query: string) => void,
}

/**
 * SearchBox: a component that shows a search form with input and search button all stylish and stuff
 *
 * PureComponent: true
 * Connected to Redux: false
 */
export const SearchBox = (props: Props) => {
  const [query, setQuery] = useState('');
  const [error, setError] = useState('');

  const resources = useSelector((state: IAppState) => state.locale);

  const onUserInput = (event: any) => {
    const newValue = (event && event.target && (event.target as any).value) || '';
    setQuery(newValue);
  };

  const onSearchSubmit = (event: any) => { // Gets angry if we use the right event type
     // Prevent the form submission from changing the URL and causing a route re-render
    event.preventDefault();

     // Remove leading/trailing and extraneous middle spaces
    const trimmedQuery = query.trim().replace(/\s\s+/g, ' ');

    // If the search contains an entry in the blacklist, do not allow it.
    const blacklistedFound = SEARCH_BLACKLIST.some((token) => trimmedQuery.includes(token));
    if (blacklistedFound) {
      setError(getResource(resources, 'GUEST_SEARCH_BOX_BLACKLISTED'));
      return;
    }

    if (!trimmedQuery || trimmedQuery.length < MinSearchLength) {
      setError(getResource(resources, 'GUEST_SEARCH_MIN_LENGTH', MinSearchLength));
      return;
    }

    props.onSearch(trimmedQuery);
    setError('');
    setQuery('');
  };

  return (
    <form>
      <Column>
        {
          error && error !== ''
            ? <ErrorText>{error}</ErrorText>
            : <ErrorPlaceholder/>
        }
        <Row>
          <TextBox autoFocus={true}
                   maxLength={50}
                   id='search-input'
                   title={getResource(resources, 'GUEST_SEARCH_IKON_GUEST')}
                   placeholder={getResource(resources, 'GUEST_SEARCH_PLACEHOLDER')}
                   value={query}
                   onChange={onUserInput}/>

          <Buttons.BigNeutral type='submit'
                              id='search-button'
                              onClick={onSearchSubmit}
                              title={getResource(resources, 'GUEST_SEARCH_IKON_GUEST')}>{getResource(resources, 'GUEST_SEARCH_SEARCH')}</Buttons.BigNeutral>
        </Row>
      </Column>
    </form>
  );
}
